import "./hero.css";
import { FaCode, FaMobileAlt, FaCloud, FaArrowRight } from "react-icons/fa";
import serviceHero from "../img/New/serviceHero.png";
import heroBgSoft from "../img/New/hero-bg-soft.png";

const ServicesHero = () => {
  return (
    <section
      className="services-hero"
      style={{ backgroundImage: `url(${heroBgSoft})` }}
    >
      <div className="services-hero__container">
        {/* CONTENT */}
        <div className="services-hero__content">
          <span className="services-hero__badge">
            Premium Software Services
          </span>

          <h1 className="services-hero__heading">
            Engineering <span>Scalable</span>
            <br />
            Digital Products
          </h1>

          <p className="services-hero__description">
            Oglitz helps startups and enterprises build reliable, scalable web,
            mobile, and cloud solutions that drive real business growth.
          </p>

          {/* ICON CHIPS */}
          <div className="services-hero__chips">
            <div className="services-hero__chip">
              <FaCode />
              <span>Custom Software</span>
            </div>
            <div className="services-hero__chip">
              <FaMobileAlt />
              <span>Mobile Apps</span>
            </div>
            <div className="services-hero__chip">
              <FaCloud />
              <span>Cloud & DevOps</span>
            </div>
          </div>

          {/* ACTIONS */}
          <div className="services-hero__actions">
            <a href="/contact" className="services-hero__btn-primary">
              Start a Project
            </a>

            <a href="/services" className="services-hero__btn-secondary">
              <span>View Services</span>
              <FaArrowRight />
            </a>
          </div>
        </div>

        {/* IMAGE */}
        <div className="services-hero__image-wrap">
          <img
            src={serviceHero}
            alt="Oglitz software services"
            className="services-hero__image"
          />
        </div>
      </div>
    </section>
  );
};

export default ServicesHero;
